import { render } from "./loginSelectTest.vue?vue&type=template&id=4a6cbf74&scoped=true"
import script from "./loginSelectTest.vue?vue&type=script&lang=js"
export * from "./loginSelectTest.vue?vue&type=script&lang=js"

import "./loginSelectTest.vue?vue&type=style&index=0&id=4a6cbf74&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6cbf74"]])

export default __exports__